// --------------------------------------------------------------------------------
// NOTE: This file was automatically generated, do not modify manually.
// --------------------------------------------------------------------------------
import { BaseMapInfo } from './BaseMapInfo';
import { VisibleTiles } from './VisibleTiles';
import { LoadBaseMapTileRequest } from './LoadBaseMapTileRequest';

export class TileData implements ITileData {
    tileMatrixIndex!: number;
    tileX!: number;
    tileY!: number;
    topLeftCornerU!: number;
    topLeftCornerV!: number;
    base64Image!: string | undefined;
    topLeftCornerLongitude!: number;
    topLeftCornerLatitude!: number;

    constructor(data?: ITileData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tileMatrixIndex = _data["tileMatrixIndex"];
            this.tileX = _data["tileX"];
            this.tileY = _data["tileY"];
            this.topLeftCornerU = _data["topLeftCornerU"];
            this.topLeftCornerV = _data["topLeftCornerV"];
            this.base64Image = _data["base64Image"];
            this.topLeftCornerLongitude = _data["topLeftCornerLongitude"];
            this.topLeftCornerLatitude = _data["topLeftCornerLatitude"];
        }
    }

    static fromJS(data: any): TileData {
        data = typeof data === 'object' ? data : {};
        let result = new TileData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tileMatrixIndex"] = this.tileMatrixIndex;
        data["tileX"] = this.tileX;
        data["tileY"] = this.tileY;
        data["topLeftCornerU"] = this.topLeftCornerU;
        data["topLeftCornerV"] = this.topLeftCornerV;
        data["base64Image"] = this.base64Image;
        data["topLeftCornerLongitude"] = this.topLeftCornerLongitude;
        data["topLeftCornerLatitude"] = this.topLeftCornerLatitude;
        return data;
    }
}

export interface ITileData {
    tileMatrixIndex: number;
    tileX: number;
    tileY: number;
    topLeftCornerU: number;
    topLeftCornerV: number;
    base64Image: string | undefined;
    topLeftCornerLongitude: number;
    topLeftCornerLatitude: number;
}